export const storage = {
  get: (key, fallback = null) => {
    try { const v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; }
    catch { return fallback; }
  },
  set: (key, val) => { try { localStorage.setItem(key, JSON.stringify(val)); } catch {} },
  remove: (key) => { try { localStorage.removeItem(key); } catch {} },
};

// Per-user chat history cache
export const chatCache = {
  key: (chatId) => `ds_msgs_${chatId}`,
  get: (chatId) => storage.get(chatCache.key(chatId), []),
  set: (chatId, msgs) => storage.set(chatCache.key(chatId), msgs),
  clear: (chatId) => storage.remove(chatCache.key(chatId)),
};
